module.exports = __webpack_public_path__ + "static/media/20200113_161334.73bccca1.jpg";